import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireAuth } from '@angular/fire/auth'
import Swal from 'sweetalert2'
@Injectable({
  providedIn: 'root'
})
export class IpsService {

  constructor(private db:AngularFirestore,private auth:AngularFireAuth) { }

  async crearIPS(nombre,tipo,direccion,coordenadas,telefono,nivel,nit,municipioIPS,departamentoIPS){
    var mes=new Date().getMonth()+1
    var fecha=mes+'/'+new Date().getFullYear()+'-'+new Date().getHours()+':'+new Date().getMinutes()
    const id=Math.random().toString(36).substring(2);
    this.db.collection("clinicas").doc(id).set({
      fechas:fecha,
      uid:id,
      nombres:nombre,
      tipos:tipo,
      direcciones:direccion,
      coordinates:coordenadas,
      telefonos:telefono,
      niveles:nivel,
      nities:nit,
      enivadas:[],
      favoritos:[],
      actividad:"",
      municipioIPSs:municipioIPS,
      departamentoIPSs:departamentoIPS,
      reaccionLikes:[],
      reaccionDislikes:[],
      likes:[],
      dislikes:[]
    }).then(()=>{
      Swal.fire('IPS registrada','operacion completada','success')
    }).catch(e=>{
      console.log(e)
    })
  
  }
}
